module.exports = __webpack_public_path__ + "static/video_480-0863f8eef46cf237daf88ff6f44c8ffb.mp4";